import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { TestModeService } from '../services/test-mode.service';

/**
 * POS Test Mode (onboarding) — reads the backend's `X-Test-Mode` response
 * header and reflects it into {@link TestModeService}, which drives the
 * persistent TEST banner.
 *
 * Test Mode is a per-store server-side configuration; the SPA only mirrors
 * it. The header is present on POS responses (the backend resolves the
 * store's StoreSetting.PosTestMode per request), so the banner appears on
 * the terminal's first POS call and clears within one request after an admin
 * switches the store to Live — no client toggle, no re-login.
 */
export const testModeInterceptor: HttpInterceptorFn = (req, next) => {
  const testMode = inject(TestModeService);
  return next(req).pipe(
    tap(event => {
      if (event instanceof HttpResponse && event.headers.has('X-Test-Mode')) {
        testMode.set(event.headers.get('X-Test-Mode') === 'true');
      }
    })
  );
};
